import axios from '@axios'

export default {
  namespaced: true,
  state: {
    categorias: [],
  },
  getters: {},
  mutations: {},
  actions: {
    fetchCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/categorias', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    countCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/categorias/count', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCategory(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/categorias/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCategory(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/categoria/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addCategory(ctx, categoryData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/categoria', categoryData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatedCategory(ctx, categoryData) {
      return new Promise((resolve, reject) => {
        const { nome, descricao, ativo } = categoryData
        axios
          .put(`/categoria/${categoryData.id}`, {
            nome,
            descricao,
            ativo,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
